<template>
    <form name="single-step-signup-form" @submit.prevent="submitSignupForm()">
        <div class="ls-single-step-signup-form">
            <ls-panel :class="{ 'ls-border-all ls-border-bottom-none': !mobile }">
                <ls-choose-your-service-form></ls-choose-your-service-form>
            </ls-panel>

            <ls-panel v-if="!desktop" :class="{ 'ls-border-horizontal': !mobile }">
                <div class="grid">
                    <div class="grid__col-12">
                        <div
                            class="ls-mowing-services__description ls-align--center"
                            data-font-size="-2"
                        >
                            <span class="ls-uppercase ls-bold">Mowing Subscription Includes</span>
                            <br />
                            <span
                                >Lawn mowing, edging, and blowing clippings off of hard
                                surfaces.</span
                            >
                        </div>
                    </div>
                </div>
            </ls-panel>
            <ls-panel
                v-if="!desktop && order.show_faq"
                :class="{ 'ls-border-horizontal': !mobile }"
            >
                <div class="single-step-signup-form__faq-container">
                    <a
                        v-ls-track.click="{ target: 'header-faq-link' }"
                        class="ls-button ls-button--block"
                        @click="openModal('faq')"
                    >
                        <h3>Questions?</h3>
                    </a>
                </div>
            </ls-panel>
            <ls-panel :class="{ 'ls-border-horizontal': !mobile }">
                <ls-contact-info></ls-contact-info>
            </ls-panel>

            <ls-panel
                :class="{
                    'ls-border-all ls-border-top-none': !mobile,
                    'ls-border-bottom-none': !desktop,
                }"
            >
                <ls-billing-information-form></ls-billing-information-form>

                <ls-error v-if="desktop"></ls-error>

                <!-- Ensure the button logic matches on both mobile and desktop implementation -->
                <div v-if="desktop" slot="button" class="grid ls-padding--top">
                    <div class="grid__col-12">
                        <div class="ls-reserve-booking__container">
                            <button
                                v-ls-track.click="{
                                    target: 'order-form--submit-button',
                                }"
                                class="ls-button ls-button--block ls-button--lg ls-button--yellow ls-reserve-booking__button"
                                type="submit"
                            >
                                <span v-if="loading.finalizingOrder"
                                    ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Booking Your
                                    Service</span
                                >
                                <span v-else>Reserve Your Booking</span>
                            </button>
                        </div>
                    </div>
                </div>
            </ls-panel>

            <ls-panel v-if="!desktop" class="ls-border-all ls-border-top-none">
                <ls-address-order-summary-panel></ls-address-order-summary-panel>
                <div class="grid">
                    <ls-error class="ls-margin--bottom"></ls-error>
                </div>

                <!-- Ensure the button logic matches on both mobile and desktop implementation -->
                <div slot="button" class="grid">
                    <div class="grid__col-12">
                        <div class="ls-reserve-booking__container">
                            <button
                                v-ls-track.click="{
                                    target: 'order-form--submit-button',
                                }"
                                class="ls-button ls-button--block ls-button--lg ls-button--yellow ls-reserve-booking__button"
                                type="submit"
                            >
                                <span v-if="loading.finalizingOrder"
                                    ><i class="fa fa-pulse fa-spinner"></i>&nbsp;Booking Your
                                    Service</span
                                >
                                <span v-else>Reserve Your Booking</span>
                            </button>
                        </div>
                    </div>
                </div>
            </ls-panel>
        </div>
    </form>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';
import eventBusService from '@/services/event-bus.service';
import lsPanel from '@/components/original-mydot/panel/Panel.vue';
import lsChooseYourServiceForm from '@/components/original-mydot/choose-your-service/ChooseYourServiceForm.vue';
import lsContactInfo from '@/components/original-mydot/contact-info/ContactInfo.vue';
import lsBillingInformationForm from '@/components/original-mydot/billing-information/BillingInformationForm.vue';
import lsAddressOrderSummaryPanel from '@/components/original-mydot/address-order-summary-panel/AddressOrderSummaryPanel.vue';
import lsError from '@/components/original-mydot/error/Error.vue';

export default {
    components: {
        lsPanel,
        lsChooseYourServiceForm,
        lsContactInfo,
        lsBillingInformationForm,
        lsAddressOrderSummaryPanel,
        lsError,
    },
    computed: {
        ...mapState([
            'contactInfo',
            'creditCard',
            'error',
            'loading',
            'billingInformation',
            'screenSize',
            'order',
        ]),
        ...mapGetters({
            mobile: types.SCREEN_SIZE__GET_MOBILE_SCREEN,
            desktop: types.SCREEN_SIZE__GET_DESKTOP_SCREEN,
        }),
        allStatesValid() {
            return this.contactInfo.valid && this.creditCard.valid && this.billingInformation.valid;
        },
    },
    methods: {
        ...mapActions({
            orderFinalizeWithPayment: types.ORDER__FINALIZE_WITH_PAYMENT,
            openModal: types.MODAL__OPEN_MODAL,
        }),
        submitSignupForm() {
            if (this.loading.finalizingOrder) {
                return;
            }
            if (!this.allStatesValid) {
                eventBusService.eventBus.$emit('submitButtonClick');
                setTimeout(() => {
                    const firstInvalidInput =
                        document.getElementsByClassName('ls-invalid')[0] ||
                        document.getElementsByClassName(
                            'ls-billing-information-form--tos-invalid'
                        )[0] ||
                        null;
                    if (firstInvalidInput) {
                        const offset = this.screenSize.xs || this.screenSize.sm ? -150 : -105; // offset to account for the sticky header + the input label
                        VueScrollTo.scrollTo(firstInvalidInput, 500, { offset });
                    }
                });
            } else {
                this.orderFinalizeWithPayment();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-single-step-signup-form {
    margin-bottom: 100px;
}

.ls-mowing-services__description {
    background-color: palette(gray, xx-light);
    color: palette(gray, mid);
    padding: rem(0);
}

.ls-reserve-booking__container {
    border-top: 1px solid palette(gray, x-light);
    padding-top: rem(0);
}

.ls-reserve-booking__button {
    min-width: 225px;
}
.single-step-signup-form__faq-container {
    margin: 0px 28px;
    padding-top: 7px;
    h3 {
        padding: 5px 0px;
    }
}
</style>
